export default "__VITE_ASSET__YrrwnSD7__"